import { HStack, LinkBox, LinkOverlay, Text } from '@cardboard-ui/react';
import { t, Trans } from '@lingui/macro';
import { TextLink } from 'apps/TenantApp/components/TextLink';
import { Card, CardContent } from 'components/cards/Card';
import { SpaceIndicator } from 'components/SpaceIndicator';
import { UserHandle } from 'components/UserHandle';
import React from 'react';
import { graphql, useFragment } from 'utils/graphClient';
import { useI18n } from 'utils/i18n';
import { generatePath, SPACE_ANNOUNCEMENTS_PATH } from 'utils/routes';
import { MinimalAnnouncementCard_announcement$key } from './__generated__/MinimalAnnouncementCard_announcement.graphql';

const fragment = graphql`
  fragment MinimalAnnouncementCard_announcement on Announcement {
    id
    publishedAt
    space {
      id
      ...SpaceIndicator_space
    }
    announcer {
      ...UserHandle_member
    }
  }
`;

interface MinimalAnnouncementCardProps {
  announcement: MinimalAnnouncementCard_announcement$key;
}

export const MinimalAnnouncementCard = ({
  announcement,
}: MinimalAnnouncementCardProps) => {
  const { space, announcer, publishedAt } = useFragment(fragment, announcement);

  const { format } = useI18n();

  const formattedDate = publishedAt
    ? format(new Date(publishedAt), 'PPPp')
    : t`Not published`;

  return (
    <LinkBox>
      <Card>
        <CardContent>
          <HStack>
            <Trans>
              <Text>
                Announcement by
                <span>
                  <UserHandle
                    linkToProfile
                    display="inline-flex"
                    member={announcer}
                  />
                </span>{' '}
                in{' '}
                <SpaceIndicator
                  linkToSpace
                  display="inline-flex"
                  space={space}
                />{' '}
                on{' '}
                <LinkOverlay
                  as={TextLink}
                  to={generatePath(SPACE_ANNOUNCEMENTS_PATH, {
                    spaceId: space.id,
                  })}
                >
                  {formattedDate}
                </LinkOverlay>
              </Text>
            </Trans>
          </HStack>
        </CardContent>
      </Card>
    </LinkBox>
  );
};
